import React from "react";
import Arrow_Icon from "../../assets/images/arrow-down.png";

const CustomSuffixIcon = () => {
  return <img src={Arrow_Icon} alt="Icon" />;
};

export default CustomSuffixIcon;
